/** A splat redirect's `href`, since a typed `to` names one route, not every route below a moved prefix. */
export function hrefBelow(prefix: `/${string}`, splat: string | undefined, searchStr: string): string {
    // The router hands the splat over decoded; each segment is encoded again, as for a splat param.
    const rest = (splat ?? '').split('/').map(encodeURIComponent).join('/');
    // `searchStr` is `location.searchStr`: empty, or the whole query string with its `?`.
    return `${prefix}${rest === '' ? '' : `/${rest}`}${searchStr}`;
}
